import Button from '@ingka/button';
import Skeleton from '@ingka/skeleton';
import chevronDownIcon from '@ingka/ssr-icon/paths/chevron-down';
import { translate } from '@repo/phrase';
import { Paragraph } from '@repo/ui/typography';

import sharedStyles from '@/components/assets/styles.module.scss';

interface Props {
    items: number;
}

const tableHeader = [
    { text: 'asset_list_table_alias', key: crypto.randomUUID() },
    { text: 'asset_list_table_type', key: crypto.randomUUID() },
    { text: 'asset_list_table_id', key: crypto.randomUUID() },
    { text: 'asset_list_table_status', key: crypto.randomUUID() },
    { text: 'asset_list_table_value', key: crypto.randomUUID() },
];

export const AssetsSkeleton = (props: Props) => {
    const { items } = props;

    const elementsToRender = Array.from({ length: items }, (_, index) => index + 1);

    return (
        <>
            <div className={sharedStyles.counter} data-testid="assets-skeleton">
                <Skeleton />
            </div>
            <div className={sharedStyles.assets_table}>
                <div className={sharedStyles.assets_table_header}>
                    <div>
                        <Button
                            text={translate('asset_list_table_creation_date')}
                            ssrIcon={chevronDownIcon}
                            iconPosition="trailing"
                            type="tertiary"
                            size="small"
                        />
                    </div>
                    {tableHeader.map((header) => (
                        <div key={header.key}>
                            <Paragraph bodySize="s">{translate(header.text)}</Paragraph>
                        </div>
                    ))}
                </div>
                {elementsToRender.map((value) => {
                    return (
                        <div key={value} className={sharedStyles.assets_table_row}>
                            <div className={sharedStyles.asset_date}>
                                <Skeleton />
                            </div>
                            <div className={sharedStyles.asset_alias}>
                                <Skeleton />
                            </div>
                            <div className={sharedStyles.asset_type}>
                                <Skeleton />
                            </div>
                            <div className={sharedStyles.asset_id}>
                                <Skeleton />
                            </div>
                            <div className={sharedStyles.asset_status}>
                                <Skeleton />
                            </div>
                            <div className={sharedStyles.asset_value}>
                                <Skeleton />
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};
